const state = {
    isActive: false,
    isActiveForced: false,
    theme: null
}

const getters = {
    isActive(state) {
        return state.isActive
    },

    isActiveForced(state) {
        return state.isActiveForced
    },

    theme(state) {
        return state.theme
    }
}

const mutations = {
    setIsActive(state, isActive) {
        if (!state.isActiveForced) {
            state.isActive = isActive
        }
    },

    setIsActiveForced(state, isActiveForced) {
        state.isActive = isActiveForced
        state.isActiveForced = isActiveForced
    },

    setTheme(state, theme) {
        if (!state.isActiveForced) {
            state.theme = theme
        }
    },

    setThemeForced(state, theme) {
        state.theme = theme
    }
}

const actions = {
    open({ commit }, theme) {
        commit('setIsActive', true)
        commit('setTheme', theme || null)
    },

    openForced({ commit }, theme) {
        commit('setIsActive', true)
        commit('setIsActiveForced', true)
        commit('setThemeForced', theme || null)
    },

    close({ commit }) {
        commit('setIsActive', false)
        commit('setTheme', null)
    },

    closeForced({ commit }) {
        commit('setIsActive', false)
        commit('setIsActiveForced', false)
        commit('setThemeForced', null)
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}